/**
 * select2
 */
window.addEventListener('load', function () {
    $('.select2-multiple').select2({
        placeholder: '-----',
        multiple: true,
        allowClear: true,
        language: 'ja',
        tags: true
    });
});
